import React from "react";
import {
  Grid,
  Container,
  Card,
  Typography,
} from "@material-ui/core";
import { TyCStyles } from "./TyCStyles";
import { useTranslation } from "react-i18next";

export function WarninLegalTyC(props) {
  const { showSideMenu } = props;
  const classes = TyCStyles();
  const { t, i18n } = useTranslation();

  return (
    <Grid className={!showSideMenu ? classes.container : classes.hideContainer}>
      <Container maxWidth={"lg"} className={classes.mainContainer}>
        <Card className={classes.cardContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography align="justify" className={classes.text}>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle01")}
                </h5>
                <p>{t("legalWarningText01_01a")}<b><a href="https://identidad.correos.es/" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText01_01b")}</a></b>{t("legalWarningText01_01c")}</p>
                <p>{t("legalWarningText01_02")}</p>
                <p>{t("legalWarningText01_03a")}<b><a href="https://www.correos.es/es/es/atencion-al-cliente/tu-consulta-tu-reclamacion/solicita-informacion" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText01_03b")}</a></b>{t("legalWarningText01_03c")}</p>
                <p>{t("legalWarningText01_04a")}<b><a href="https://www.correos.es/es/es/atencion-al-cliente" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText01_04b")}</a></b></p>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle02")}
                </h5>
                <p>{t("legalWarningText02_01a")}<b><a href="https://identidad.correos.es/" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText02_01b")}</a></b>{t("legalWarningText02_01c")}</p>
                <p>{t("legalWarningText02_02")}</p>
                <p>{t("legalWarningText02_03a")}<b><a href="https://identidad.correos.es/" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText02_03b")}</a></b>{t("legalWarningText02_03c")}</p>
                <p>{t("legalWarningText02_04a")}<b><a href="https://identidad.correos.es/" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText02_04b")}</a></b>{t("legalWarningText02_04c")}</p>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle03")}
                </h5>
                <p>{t("legalWarningText03_01")}</p>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle04")}
                </h5>
                <p>{t("legalWarningText04_01a")}<b><a href="https://identidad.correos.es/" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText04_01b")}</a></b>{t("legalWarningText04_01c")}</p>
                <p>{t("legalWarningText04_02")}</p>
                <p>{t("legalWarningText04_03")}</p>
                <p>{t("legalWarningText04_04")}</p>
                <p>{t("legalWarningText04_05")}</p>
                <p>{t("legalWarningText04_06")}</p>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle05")}
                </h5>
                <p>{t("legalWarningText05_01")}</p>
                <p>{t("legalWarningText05_02a")}<b><a href="https://identidad.correos.es/TyC/Pol%C3%ADticaDeCookies" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText05_02b")}</a></b></p>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle06")}
                </h5>
                <p>{t("legalWarningText06_01")}</p>
                <p>{t("legalWarningText06_02")}</p>
                <p>{t("legalWarningText06_03")}</p>
                <p>{t("legalWarningText06_04")}</p>
                <p>{t("legalWarningText06_05")}</p>
                <p>{t("legalWarningText06_06")}</p>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle07")}
                </h5>
                <p>{t("legalWarningText07_01a")}<b><a href="https://identidad.correos.es/TyC/Pol%C3%ADticaDePrivacidad" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText07_01b")}</a></b>
                {t("legalWarningText07_01c")}<b><a href="https://identidad.correos.es/TyC/Pol%C3%ADticaDeCookies" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText07_01d")}</a></b>
                {t("legalWarningText07_01e")}<b><a href="https://descargas.correos.es/Publico/correosid/policiescid.html" className={classes.links} target="_blank" rel="noopener noreferrer">{t("legalWarningText07_01f")}</a></b>
                {t("legalWarningText07_01g")}</p>
                <h5 className={classes.subtitles}>
                  {t("legalWarningTitle08")}
                </h5>
                <p>{t("legalWarningText08_01")}</p>
              </Typography>
            </Grid>
          </Grid>
        </Card>
      </Container>
    </Grid>
  );
}
